import { render, staticRenderFns } from "./infoChargeUsePattern.vue?vue&type=template&id=24b1f44d&"
import script from "./infoChargeUsePattern.vue?vue&type=script&lang=js&"
export * from "./infoChargeUsePattern.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports